import React from 'react'
import { IoIosArrowBack } from 'react-icons/io'
import { useHistory, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
export interface ConfirmParamater {}

export interface BackButtonProps {
  rootPaths: string[]
  size?: number
  status?: boolean
  message?: string
}

const BackButton: React.FC<BackButtonProps> = ({
  rootPaths,
  size,
  status,
  message
}) => {
  const history = useHistory()
  const location = useLocation()
  return (
    <>
      {rootPaths.indexOf(location.pathname) < 0 && (
        <IoIosArrowBack
          size={size}
          onClick={() => {
            if (!status) {
              history.goBack()
            } else {
              toast.warn(message, { autoClose: 3000 })
            }
          }}
        />
      )}
    </>
  )
}

export default BackButton
